import React from "react";
import { FirstScreenLeft, FirstScreenMain, FirstScreenRight, FirstScreenWrapper } from "./FirstScreen.styled";
import { MarqueeComponent } from "./Marquee/Marquee";
import { FirstScreenImg } from "../../assets/img/FirstScreenImg.js";
import { useNavigate } from "react-router-dom";

export const FirstScreen = () => {
  const navigate = useNavigate();
  return (
    <FirstScreenWrapper>
      <div className='container'>
        <FirstScreenMain>
          <FirstScreenLeft>
            <h1>
              Discover Best Digital Art and Collect <span>NFTs</span>
            </h1>
            <h5>TonTake is simplicity and accessibility of interaction, but not functionality. We run from creating complex wallets.</h5>
            <button onClick={() => navigate(`/marketplace`)}>Explore</button>
          </FirstScreenLeft>
          <FirstScreenRight>{FirstScreenImg()}</FirstScreenRight>
        </FirstScreenMain>
      </div>
      <MarqueeComponent />
    </FirstScreenWrapper>
  );
};
